import { Controller } from '@hotwired/stimulus';
import { initFlowbite } from 'flowbite';
import 'flowbite/dist/flowbite.turbo.js';

export default class extends Controller {
  connect() {
    initFlowbite();
  }
}
